import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ScheduleOutlinedIcon from 'components/material-symbol/icons/Schedule'
import { useStyles } from './styles'

export const NextSessionCard = ({ lesson, onOpenLesson }) => {
  const classes = useStyles()
  const { dateBadge, title, coachFacilityLine, timePillLabel } = lesson

  const handleOpen = () => onOpenLesson(lesson)
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleOpen()
    }
  }

  return (
    <Box
      className={`${classes.sessionCard} ${classes.nextSessionCard}`}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <Box className={classes.nextSessionBody}>
        <Box className={classes.dateBadge} aria-hidden="true">
          <Typography component="span" className={classes.dateBadgeMonth}>
            {dateBadge.month}
          </Typography>
          <Typography component="span" className={classes.dateBadgeDay}>
            {dateBadge.day}
          </Typography>
          <Typography component="span" className={classes.dateBadgeWeekday}>
            {dateBadge.weekday}
          </Typography>
        </Box>

        <Box className={classes.sessionCopy}>
          <Typography component="h4" className={classes.sessionTitle}>
            {title}
          </Typography>
          {coachFacilityLine ? (
            <Typography component="p" className={classes.sessionMeta}>
              {coachFacilityLine}
            </Typography>
          ) : null}
          <Box className={classes.timePill}>
            <ScheduleOutlinedIcon fontSize="small" opticalSize={16} />
            <span>{timePillLabel}</span>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export const LaterSessionCard = ({ lesson, onOpenLesson }) => {
  const classes = useStyles()
  const { dateCompact, title, laterSummaryLabel } = lesson

  const handleOpen = () => onOpenLesson(lesson)
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleOpen()
    }
  }

  return (
    <Box
      className={`${classes.sessionCard} ${classes.laterSessionCard}`}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <Box className={classes.laterSessionBody}>
        <Box className={classes.dateCompact} aria-hidden="true">
          <Typography component="span" className={classes.dateCompactWeekday}>
            {dateCompact.weekday}
          </Typography>
          <Typography component="span" className={classes.dateCompactDay}>
            {dateCompact.day}
          </Typography>
        </Box>

        <Box className={classes.sessionCopy}>
          <Typography component="h4" className={classes.laterSessionTitle}>
            {title}
          </Typography>
          <Typography component="p" className={classes.laterSessionMeta}>
            {laterSummaryLabel}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
